import React from 'react';
import '../styles/gallery.css'; 

export default function Gallery2() {
  return (
    <section className="gallery">
      <img
        src="/dibujos/portafolio33.png"
        alt="galeria"
        className="gallery-image"
        loading="lazy"
      />
      
    </section>
  );
}